import {
	createEngagementCommentParent,
	updateEngagementCommentEntity,
	createEngagementCommentReply
} from '../../../../actions/EngagementComments/engagementcommentactions';
import {
	EngagementCommentInputModalModes,
	clientSideEventNames,
	formBodyType,
	CardTypes,
	EngagementCommentStatus
} from '../../../../util/uiconstants';
import Utility from '../../../../util/utilityfunctions';

const maxCommentLength = 4000;

const validCardTypes = [CardTypes.DefaultView, CardTypes.CardView, CardTypes.CardViewTop];

const invalidBodyTypes = [formBodyType.Spacer];

function applyFilter(comments, filter) {
	let filteredComments = comments;

	if (filter) {
		filteredComments = [];

		comments &&
			comments.map((c) => {
				if (filter(c)) {
					filteredComments.push(c);
				}
			});
	}

	return Utility.normalize(filteredComments, undefined, 'engagementCommentGuid');
}

export const validCommentStatuses = [EngagementCommentStatus.open, EngagementCommentStatus.cleared];

export function validate(comment, isRecordingInprogress, voiceData) {
	let valid = true;

	if (comment) {
		if (!comment.isChild) {
			valid = valid && validateAssignedTo(comment.assignedToUserId);
			valid = valid && validatePriority(comment.priorityTypeId);
			valid = valid && validateDueDate(comment.dueDate);
		}

		valid = valid && (validateText(comment.commentText) || validateVoiceNote(voiceData)) && !isRecordingInprogress;
	} else {
		valid = false;
	}

	return valid;
}

export function save(comment, mode) {
	if (mode === EngagementCommentInputModalModes.create) {
		if (comment.content.isChild) {
			return createEngagementCommentReply(
				comment.engagementId,
				comment.content,
				comment.isGuest,
				comment.documentId,
				comment.documentTypeId
			);
		} else {
			return createEngagementCommentParent(
				comment.engagementId,
				comment.content,
				comment.isGuest,
				comment.documentId,
				comment.documentTypeId
			);
		}
	} else {
		return updateEngagementCommentEntity(
			comment.engagementId,
			comment.content,
			comment.isGuest,
			comment.documentId,
			comment.documentTypeId
		);
	}
}

export function validateAssignedTo(assignedTo) {
	return assignedTo && assignedTo !== 'undefined' && assignedTo !== null;
}

export function validatePriority(priority) {
	return priority && priority !== 'undefined' && priority !== null;
}

export function validateDueDate(dueDate) {
	return dueDate && dueDate !== 'undefined' && dueDate !== null;
}

export function validateVoiceNote(voiceNote) {
	return voiceNote && voiceNote !== 'undefined' && voiceNote !== null;
}

export function validateText(text) {
	const _text = decodeURIComponentSafe(text?.trim());
	if (_text) {
		return _text.length > 0 && _text.length <= maxCommentLength;
	}
	return true;
}

export function decodeURIComponentSafe(s) {
	if (!s) {
		return s;
	}
	if (s.includes('%')) {
		return decodeURIComponent(s.replace(/%(?![0-9][0-9a-fA-F]+)/g, '%25'));
	} else {
		return decodeURIComponent(s.trim());
	}
}

export function dispatchModalDisplay(isAresView, bodyId, bodyTypeId, documentTypeId) {
	window.dispatchEvent(new CustomEvent(clientSideEventNames.closeCommentsModal));
	if (isAresView) {
		window.dispatchEvent(
			new CustomEvent(clientSideEventNames.showCommentsModal, {
				detail: {bodyId: bodyId, documentTypeId: documentTypeId, show: true}
			})
		);
	} else if (bodyTypeId !== formBodyType.TextResponse) {
		window.dispatchEvent(
			new CustomEvent(clientSideEventNames.showCommentsModal, {
				detail: {bodyId: bodyId, documentTypeId: documentTypeId, show: true}
			})
		);
	}
	//<StyledCommentsIcon className="comments-icon" id={'commentsIconWrapper-' + bodyModel.id}></StyledCommentsIcon>
	$('span[id^=cmtIcon]').removeClass('active');
	$('#cmtIcon-' + bodyId).addClass('active');
	$('.comments-icon.active').removeClass('active');
	$('#commentsIconWrapper-' + bodyId).addClass('active');
}

export function isActiveComment(comment) {
	return validCommentStatuses.indexOf(comment.engagementCommentStatusId) !== -1;
}

export function isValidCardType(cardTypeId) {
	return validCardTypes.indexOf(cardTypeId) !== -1;
}

export function hasActiveComments(comments) {
	let result = false;
	let index = 0;

	if (comments.allIds.length > 0) {
		do {
			let id = comments.allIds[index];
			let comment = comments.byId[id];

			result = isActiveComment(comment);

			index++;
		} while (!result && index < comments.allIds.length);
	}

	return result;
}

export function isValidBodyType(bodyTypeId) {
	return invalidBodyTypes.indexOf(bodyTypeId) === -1;
}

export function getCommentsAmmountBySection(formDataSlice, commentsSlice, sectionId, filter) {
	let count = 0;

	if (formDataSlice?.length > 0) {
		let section = formDataSlice.find((section) => section.sectionId === sectionId);
		if (section?.bodies?.length > 0) {
			for (let i = 0; i < section.bodies.length; i++) {
				let body = section.bodies[i];
				let comments = commentsSelector(formDataSlice, commentsSlice, body.id, filter);
				count += comments.allIds.length;
			}
		}
	}

	return count;
}

export function getCommentsAmmountByHeader(headersSlice, formDataSlice, commentsSlice, headerId, filter) {
	let count = 0;
	let header = headersSlice.byId[headerId];

	if (header.sections?.length > 0) {
		header.sections.map((sectionId) => {
			count += getCommentsAmmountBySection(formDataSlice, commentsSlice, sectionId, filter);
		});
	}

	return count;
}

//We have two sources for comments:
//1) FormData: The comments we get through the formbodies get api (We usually populate the comments counter with this one).
//2) EngagementComments: The updated on demand comments which the user interacts with.
//We are required to sum all bodies active comments (hasActiveComments()) in the same section. Since not all bodies will have this last slice (engagementComments)
//updated with its information on body level, we have to prioritize the ones updated over the ones that come from formData.
export function commentsSelector(formDataSlice, commentsSlice, bodyId, filter) {
	let result;
	let updatedComments = commentsSlice && commentsSlice[bodyId];

	if (updatedComments !== undefined) {
		result = applyFilter(updatedComments, filter);
	} else {
		let section = formDataSlice.find(
			(section) => section?.bodies?.length > 0 && section.bodies.find((body) => body.id === bodyId) !== undefined
		);
		let formBody = section && section.bodies.find((body) => body.id === bodyId);

		result = applyFilter(formBody && formBody.engagementComments, filter);
	}

	return result;
}
